import { createSlice } from "@reduxjs/toolkit";
import { doDetailLiveTracking, doDetailLiveTrackingNoFetching } from "./thunk";

const liveTrackingSlice = createSlice({
  name: "liveTracking",
  initialState: {
    isFetching: false,
    data: null,
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(doDetailLiveTracking.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(doDetailLiveTracking.fulfilled, (state, action) => {
      state.isFetching = false;
      state.data = action.payload;
    });
    builder.addCase(doDetailLiveTracking.rejected, state => {
      state.isFetching = false;
    });
    builder.addCase(doDetailLiveTrackingNoFetching.fulfilled, (state, action) => {
      state.data = action.payload;
    });
  },
});

const { reducer: liveTrackingReducer } = liveTrackingSlice;
export default liveTrackingReducer;
